module.exports = __webpack_public_path__ + "img/sv4.97e9b19b.svg";